export default __webpack_public_path__ + "static/tablet_KV13-c4eea37e0298a289a04a504e92d2ec43.mp4";